<template>
  <b-container :class="`${containerClass} ${fixed === false ? 'notFixedTableContainer' : ''}`">
    <b-row>
      <b-col
        :cols="(beforeSearch && beforeSearch.cols) || innerBeforeSearch.cols"
        :sm="(beforeSearch && beforeSearch.sm) || innerBeforeSearch.sm"
        :md="(beforeSearch && beforeSearch.md) || innerBeforeSearch.md"
        :lg="(beforeSearch && beforeSearch.lg) || innerBeforeSearch.lg"
        :xl="(beforeSearch && beforeSearch.xl) || innerBeforeSearch.xl"
      >
        <slot name="before-search" />
      </b-col>
    </b-row>

    <b-row>
      <b-col
        :cols="(rowBeforeSearch && rowBeforeSearch.cols) || innerRowBeforeSearch.cols"
        :sm="(rowBeforeSearch && rowBeforeSearch.sm) || innerRowBeforeSearch.sm"
        :md="(rowBeforeSearch && rowBeforeSearch.md) || innerRowBeforeSearch.md"
        :lg="(rowBeforeSearch && rowBeforeSearch.lg) || innerRowBeforeSearch.lg"
        :xl="(rowBeforeSearch && rowBeforeSearch.xl) || innerRowBeforeSearch.xl"
        :order="(rowBeforeSearch && rowBeforeSearch.order) || innerRowBeforeSearch.order"
        :order-sm="(rowBeforeSearch && rowBeforeSearch.orderSm) || innerRowBeforeSearch.orderSm"
        :order-md="(rowBeforeSearch && rowBeforeSearch.orderMd) || innerRowBeforeSearch.orderMd"
        :order-lg="(rowBeforeSearch && rowBeforeSearch.orderLg) || innerRowBeforeSearch.orderLg"
      >
        <slot name="row-before-search" />
      </b-col>

      <b-col
        :cols="(rowSearch && rowSearch.cols) || innerRowSearch.cols"
        :sm="(rowSearch && rowSearch.sm) || innerRowSearch.sm"
        :md="(rowSearch && rowSearch.md) || innerRowSearch.md"
        :lg="(rowSearch && rowSearch.lg) || innerRowSearch.lg"
        :xl="(rowSearch && rowSearch.xl) || innerRowSearch.xl"
        :order="(rowSearch && rowSearch.order) ||  innerRowSearch.order"
        :order-sm="(rowSearch && rowSearch.orderSm) ||  innerRowSearch.orderSm"
        :order-md="(rowSearch && rowSearch.orderMd) ||  innerRowSearch.orderMd"
        :order-lg="(rowSearch && rowSearch.orderLg) ||  innerRowSearch.orderLg"
      >
        <b-form-group>
          <b-input-group>
            <b-input-group-prepend class="border-0">
              <div class="form-control">
                <font-awesome-icon icon="search" class="" />
              </div>
            </b-input-group-prepend>

            <b-form-input
              v-model="filter"
              class="border-left-0"
              :id="searchId"
              :placeholder="searchPlaceHolder"
            >
            </b-form-input>

            <b-input-group-append>
              <b-button
                :disabled="!filter"
                @click="filter = ''"
                class="nw-clear-search"
              >
                <font-awesome-icon icon="trash" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>

      <b-col v-if="showSelectAll" cols="12" sm="12" md="12" lg="12" xl="12">
        <b-container>
          <b-row align-h="start" class="mb-1">
            <b-button
              v-on:click="selectAll(!allChecked)"
              class="mb-2"
              v-if="showSelection"
            >
              {{ allChecked }}
            </b-button>
          </b-row>
        </b-container>
      </b-col>

      <b-col
        :cols="(rowAfterSearch && rowAfterSearch.cols) ||  innerRowAfterSearch.cols"
        :sm="(rowAfterSearch && rowAfterSearch.sm) ||  innerRowAfterSearch.sm"
        :md="(rowAfterSearch && rowAfterSearch.md) ||  innerRowAfterSearch.md"
        :lg="(rowAfterSearch && rowAfterSearch.lg) ||  innerRowAfterSearch.lg"
        :xl="(rowAfterSearch && rowAfterSearch.xl) ||  innerRowAfterSearch.xl"
        :order="(rowAfterSearch && rowAfterSearch.order) ||  innerRowAfterSearch.order"
        :order-sm="(rowAfterSearch && rowAfterSearch.orderSm) ||  innerRowAfterSearch.orderSm"
        :order-md="(rowAfterSearch && rowAfterSearch.orderMd) ||  innerRowAfterSearch.orderMd"
        :order-lg="(rowAfterSearch && rowAfterSearch.orderLg) ||  innerRowAfterSearch.orderLg"
        :order-xl="(rowAfterSearch && rowAfterSearch.orderXl) ||  innerRowAfterSearch.orderXl"
      >
        <slot name="row-after-search" />
      </b-col>
    </b-row>

    <b-row>
      <b-col
        :cols="(afterSearch && afterSearch.cols) ||  innerAfterSearch.cols"
        :sm="(afterSearch && afterSearch.sm) ||  innerAfterSearch.sm"
        :md="(afterSearch && afterSearch.md) ||  innerAfterSearch.md"
        :lg="(afterSearch && afterSearch.lg) ||  innerAfterSearch.lg"
        :xl="(afterSearch && afterSearch.xl) ||  innerAfterSearch.xl"
      >
        <slot name="after-search" />
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <div ref="tableContainer" :class="`${fixed === false ? 'mb-2 tableContainerNotFixed' : 'tableContainer'}`"
             :style="{ overflow: fixed === false ? 'auto' : 'none'}">
          <b-table
            :id="idTable"
            responsive="true"
            :ref="refTable"
            :empty-text="emptyText"
            :empty-filtered-text="''"
            data-filter-control="true"
            striped
            :fixed="fixed !== false ? true : null"
            show-empty
            :busy.sync="isBusy"
            :items="componentItems"
            :thead-tr-class="getTheadTRClass()"
            :stacked="stackedModeOn"
            :fields="componentFields"
            :current-page="currentPage"
            :per-page="perPage"

            :no-provider-paging="true"
            :no-provider-sorting="true"
            :no-provider-filtering="true"
            @context-changed="checkItems"
            @row-clicked="watchItem(componentItems)"
            :sort-compare="mySortCompare"
            :class="stackedModeOn ? 'stackedStyle' : (fixed === false ? 'notFixed' : 'notStackedStyle')"
          >
            <template
              v-for="field in customFields || []"
              v-slot:[getCustomField(field)]="row"
              v-show="!field.hideInTable"
            >
              <slot :name="field.key" :item="row.item" />
            </template>

            <template v-slot:cell(select)="row">
              <b-form-checkbox
                @click.native.stop
                v-on:change="itemSelected(row.item, $event)"
                :size="stackedModeOn ? 'sm' : 'md'"
                v-model="row.item.selected"
              >
              </b-form-checkbox>
            </template>

            <template v-slot:head(select)>
              <b-form-checkbox
                @click.native.stop
                v-on:change="selectAll(!allChecked)"
                v-model="allChecked"
                :size="stackedModeOn ? 'sm' : 'md'"
                ref="checkAllBox"
              >
              </b-form-checkbox>
            </template>

            <template v-slot:cell(edit)="row">
              <b-button @click="$emit('rowEdit', row)">
                <font-awesome-icon icon="pencil-alt" />
              </b-button>
            </template>

            <template v-slot:cell(delete)="row">
              <b-button @click="$emit('rowDelete', row)">
                <font-awesome-icon icon="trash-alt" />
              </b-button>
            </template>

            <template v-slot:cell(info)="row">
              <b-button @click="$emit('rowInfo', row)">
                <font-awesome-icon icon="eye" />
              </b-button>
            </template>

            <template v-slot:cell(download)="row">
              <b-button @click="$emit('rowDownload', row)">
                <font-awesome-icon icon="download" />
              </b-button>
            </template>

            <template v-slot:cell(stacked-mode)="row">
              <b-button
                v-on:click="
                  changeSelection(row && row.item && row.item.selected).then(result => {
                    if (row && row.item) row.item.selected = result;
                  })
                "
                :true-value="row && row.item && row.item.selected ? 'true' : 'false'"
                v-if="showSelection"
                class="ml-1 select-button"
              >
                {{ row && row.item && row.item.selected }}
              </b-button>

              <b-button
                class="mr-2"
                @click="$emit('rowEdit', row)"
                v-if="showEdit"
              >
                <font-awesome-icon icon="pencil-alt" class="align-self-end" />
              </b-button>

              <b-button
                class="mr-2"
                @click="$emit('rowDelete', row)"
                v-if="showDelete"
              >
                <font-awesome-icon icon="trash-alt" class="align-self-end" />
              </b-button>

              <b-button
                class="mr-2"
                @click="$emit('rowInfo', row)"
                v-if="showInfo"
              >
                <font-awesome-icon icon="eye" class="align-self-end" />
              </b-button>
            </template>
          </b-table>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col
        :cols="(beforePagination && beforePagination.cols) ||  innerBeforePagination.cols"
        :sm="(beforePagination && beforePagination.sm) ||  innerBeforePagination.sm"
        :md="(beforePagination && beforePagination.md) ||  innerBeforePagination.md"
        :lg="(beforePagination && beforePagination.lg) ||  innerBeforePagination.lg"
        :xl="(beforePagination && beforePagination.xl) ||  innerBeforePagination.xl"
      >
        <slot name="before-pagination" />
      </b-col>
    </b-row>

    <b-row>
      <b-col
        :cols="(rowBeforePagination && rowBeforePagination.cols) ||  innerRowBeforePagination.cols"
        :sm="(rowBeforePagination && rowBeforePagination.sm) ||  innerRowBeforePagination.sm"
        :md="(rowBeforePagination && rowBeforePagination.md) ||  innerRowBeforePagination.md"
        :lg="(rowBeforePagination && rowBeforePagination.lg) ||  innerRowBeforePagination.lg"
        :xl="(rowBeforePagination && rowBeforePagination.xl) ||  innerRowBeforePagination.xl"
      >
        <slot name="row-before-pagination" />
      </b-col>

      <b-col
        :cols="(rowPagination && rowPagination.cols) ||  innerRowPagination.cols"
        :sm="(rowPagination && rowPagination.sm) ||  innerRowPagination.sm"
        :md="(rowPagination && rowPagination.md) ||  innerRowPagination.md"
        :lg="(rowPagination && rowPagination.lg) ||  innerRowPagination.lg"
        :xl="(rowPagination && rowPagination.xl) ||  innerRowPagination.xl"
      >
        <b-pagination
          id="table-pagination"
          :total-rows="componentItems && componentItems.length"
          :per-page="perPage"
          v-model="currentPage"
          :size="stackedModeOn ? 'sm' : 'md'"
          :class="noPaginationMargin ? 'm-0' : ''"
        >
        </b-pagination>
      </b-col>

      <b-col
        :cols="(rowBetweenPagination && rowBetweenPagination.cols) ||  innerRowBetweenPagination.cols"
        :sm="(rowBetweenPagination && rowBetweenPagination.sm) ||  innerRowBetweenPagination.sm"
        :md="(rowBetweenPagination && rowBetweenPagination.md) ||  innerRowBetweenPagination.md"
        :lg="(rowBetweenPagination && rowBetweenPagination.lg) ||  innerRowBetweenPagination.lg"
        :xl="(rowBetweenPagination && rowBetweenPagination.xl) ||  innerRowBetweenPagination.xl"
      >
        <slot name="row-between-pagination" />
      </b-col>

      <b-col
        :cols="(rowPerPage && rowPerPage.cols) ||  innerRowPerPage.cols"
        :sm="(rowPerPage && rowPerPage.sm) ||  innerRowPerPage.sm"
        :md="(rowPerPage && rowPerPage.md) ||  innerRowPerPage.md"
        :lg="(rowPerPage && rowPerPage.lg) ||  innerRowPerPage.lg"
        :xl="(rowPerPage && rowPerPage.xl) ||  innerRowPerPage.xl"
      >
        <b-form-group horizontal :label="''" class="mb-0" :label-cols="5">
          <b-form-select :options="pageOptions" v-model="perPage" />
        </b-form-group>
      </b-col>

      <b-col
        :cols="(rowAfterPerPage && rowAfterPerPage.cols) ||  innerRowAfterPerPage.cols"
        :sm="(rowAfterPerPage && rowAfterPerPage.sm) ||  innerRowAfterPerPage.sm"
        :md="(rowAfterPerPage && rowAfterPerPage.md) ||  innerRowAfterPerPage.md"
        :lg="(rowAfterPerPage && rowAfterPerPage.lg) ||  innerRowAfterPerPage.lg"
        :xl="(rowAfterPerPage && rowAfterPerPage.xl) ||  innerRowAfterPerPage.xl"
      >
        <slot name="row-after-per-page" />
      </b-col>
    </b-row>

    <b-row>
      <b-col
        :cols="(afterPagination && afterPagination.cols) ||  innerAfterPagination.cols"
        :sm="(afterPagination && afterPagination.sm) ||  innerAfterPagination.sm"
        :md="(afterPagination && afterPagination.md) ||  innerAfterPagination.md"
        :lg="(afterPagination && afterPagination.lg) ||  innerAfterPagination.lg"
        :xl="(afterPagination && afterPagination.xl) ||  innerAfterPagination.xl"
      >
        <slot name="after-pagination" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Vue from 'vue'
const { cloneDeep, concat, first, slice } = require('lodash')

export default {
  name: 'StandardTable',
  props: [
    // main table props
    'id-table',
    'ref-table',
    'empty-text',
    'items',
    'fields',
    'fullWidth',
    'noContainerPadding',
    'search-id',
    'customFields',
    'disableAutoUnSelection',
    'fixed',
    'noPaginationMargin',
    // props before table
    'search-place-holder',
    'before-search',
    'row-before-search',
    'row-search',
    'row-after-search',
    'after-search',
    // props after table
    'before-pagination',
    'row-before-pagination',
    'row-pagination',
    'row-between-pagination',
    'row-per-page',
    'row-after-per-page',
    'after-pagination'
  ],
  created () {
    const editedFields = []
    if (this.fields && this.fields.length !== 0) {
      this.fields.forEach(field => {
        if (!field.hideInTable) {
          editedFields.push(field)
        }
      })
    }
    this.originalItems = cloneDeep(this.items)
    this.originalFields = cloneDeep(this.fields)
    this.componentFields = this.getFields(editedFields, this.customFields)
    this.checkWindowSize()
    this.resetWatcher()
    this.addWatcher()
  },
  mounted () {
    this.componentItems = cloneDeep(this.items)
    this.checkItems({ sortBy: this.sortBy, sortDesc: this.sortDesc })
    this.containerClass = this.getContainerClass()
    this.$root.$on('reset-links', () => this.checkWindowSize())
    this.$root.$on('resize', () => {
      this.checkWindowSize()
    })
    this.$nextTick(() => {
      this.checkWindowSize()
      this.$emit('mounted')
    })
  },
  beforeDestroy () {
    window.onresize = null
    this.resetWatcher()
  },
  updated () {
    this.checkSelected()
  },
  watch: {
    filter (newVal) {
      const originalItems = cloneDeep(this.originalItems)
      const originalFields = cloneDeep(this.originalFields.length !== 0 ? this.originalFields : this.componentFields)

      this.componentItems = []
      if (newVal) {
        this.componentItems = Vue.myTableFilter(originalItems, originalFields, newVal)
      } else {
        this.componentItems = originalItems
      }
    },
    items (newVal) {
      this.componentItems = newVal
      this.originalItems = newVal
      this.checkWindowSize()
    },
    fields (newVal) {
      const editedFields = []
      newVal.forEach(field => {
        if (!field.hideInTable) {
          editedFields.push(field)
        }
      })
      this.componentFields = this.getFields(editedFields, this.customFields)
      this.checkWindowSize()
    },
    customFields () {
      this.checkWindowSize()
    },
    fullWidth () {
      this.containerClass = this.getContainerClass()
    },
    noContainerPadding () {
      this.containerClass = this.getContainerClass()
    },
    perPage (newVal) {
      this.allChecked = Vue.checkAllSelected(
        this.componentItems,
        newVal,
        this.currentPage
      )
      this.$emit('perPage', this.perPage)
    },
    currentPage (newVal) {
      this.allChecked = Vue.checkAllSelected(
        this.componentItems,
        this.perPage,
        newVal
      )
      this.$emit('currentPage', this.currentPage)
    }
  },
  data () {
    return {
      componentItems: [],
      originalItems: [],
      componentFields: [],
      originalFields: [],
      isBusy: false,
      filter: null,
      currentPage: 1,
      pageOptions: [5, 10, 25, 50],
      perPage: 10,
      allChecked: false,
      showSelectAll: false,
      size: '',
      watcher: null,
      containerClass: '',
      sortBy: null,
      sortDesc: null,
      stackedModeOn: true,
      showSelection: false,
      showEdit: false,
      showDelete: false,
      showInfo: false,
      innerBeforeSearch: { cols: 12, sm: 12, md: 12, lg: 12, xl: 12 },
      innerRowBeforeSearch: {
        cols: 12,
        sm: 12,
        md: 12,
        lg: 12,
        xl: 12,
        order: 1,
        orderSm: 1,
        orderMd: 1,
        orderLg: 1,
        orderXl: 1
      },
      innerRowSearch: {
        cols: 12,
        sm: 12,
        md: 12,
        lg: 12,
        xl: 12,
        order: 2,
        orderSm: 2,
        orderMd: 2,
        orderLg: 2,
        orderXl: 2
      },
      innerRowAfterSearch: {
        cols: 12,
        sm: 12,
        md: 12,
        lg: 12,
        xl: 12,
        order: 3,
        orderSm: 3,
        orderMd: 3,
        orderLg: 3,
        orderXl: 3
      },
      innerAfterSearch: { cols: 12, sm: 12, md: 12, lg: 12, xl: 12 },
      innerBeforePagination: { cols: 12, sm: 12, md: 12, lg: 12, xl: 12 },
      innerRowBeforePagination: { cols: 12, sm: 12, md: 12, lg: 12, xl: 12 },
      innerRowPagination: { cols: 10, sm: 10, md: 8, lg: 7, xl: 7 },
      innerRowBetweenPagination: { cols: 12, sm: 12, md: 1, lg: 1, xl: 1 },
      innerRowPerPage: { cols: 12, sm: 12, md: 4, lg: 3, xl: 3 },
      innerRowAfterPerPage: { cols: 12, sm: 12, md: 12, lg: 12, xl: 12 },
      innerAfterPagination: { cols: 12, sm: 12, md: 12, lg: 12, xl: 12 }
    }
  },
  methods: {
    resetWatcher () {
      if (this.watcher) {
        this.watcher()
      }
    },
    mySortCompare (a, b, key) {
      if (key === 'date') {
        // Assuming the date field is a `Date` object, subtraction
        // works on the date serial number (epoch value)
        return a[key] - b[key]
      } else {
        // Let b-table handle sorting other fields (other than `date` field)
        return false
      }
    },
    addWatcher () {
      this.watcher = this.$watch(
        'componentItems',
        newVal => {
          this.allChecked = Vue.checkAllSelected(
            newVal,
            this.perPage,
            this.currentPage
          )
        },
        { deep: true }
      )
    },
    selectAll (allChecked) {
      this.resetWatcher()
      const newValue = Vue.mySelectAll(
        this.componentItems,
        allChecked,
        this.perPage,
        this.currentPage,
        this.disableAutoUnSelection
      )
      this.componentItems = []
      this.addWatcher()
      this.componentItems = newValue
      this.$emit('allSelected', newValue)
    },
    checkItems (ctx, newItems) {
      if (ctx.sortBy) {
        const foundedField = find(
          this.componentFields,
          obj => obj.key === ctx.sortBy
        )
        this.sortBy = ctx.sortBy
        this.sortDesc = ctx.sortDesc
        this.resetWatcher()
        const result = Vue.myTableSorted(
          newItems || this.componentItems,
          ctx.sortBy,
          ctx.sortDesc,
          foundedField && foundedField.isDate
        )

        this.componentItems = []

        this.allChecked = Vue.checkAllSelected(
          result,
          this.perPage,
          this.currentPage
        )

        this.componentItems = cloneDeep(result)
        this.addWatcher()
      }
    },
    checkWindowSize () {
      const size = Vue.myGetWindowSize()
      let activeStackedSelectAll = false
      const editedFields = []
      const stackedModeOn = size === 'sm' || size === 'cols' || size === 'md'

      this.size = size
      this.showSelection = false
      this.showEdit = false
      this.showDelete = false
      this.showInfo = false
      this.stackedModeOn = stackedModeOn

      if (this.fields && this.fields.length !== 0) {
        this.fields.forEach(field => {
          if (field.key === 'selected' && stackedModeOn) {
            activeStackedSelectAll = true
            this.showSelection = true
          } else if (field.key === 'delete' && stackedModeOn) {
            this.showDelete = true
          } else if (field.key === 'edit' && stackedModeOn) {
            this.showEdit = true
          } else if (field.key === 'info' && stackedModeOn) {
            this.showInfo = true
          } else if (!field.hideInTable) {
            editedFields.push(field)
          }
        })
      }
      if (activeStackedSelectAll) {
        this.showSelectAll = stackedModeOn
      }
      if (stackedModeOn) {
        editedFields.push({ key: 'stacked-mode', label: '' })
      }

      this.componentFields = this.getFields(editedFields, this.customFields)
      if (this.$refs.tableContainer && this.fixed === false && !stackedModeOn) {
        // TODO find another solution to fix table's CSS class instead bypass trough ref
        const container = this.$refs.tableContainer
        const firstChild = first(container.children)
        if (firstChild) {
          const innerTable = first(firstChild.children)
          if (innerTable) innerTable.className = 'table b-table table-striped'
        }
      }
    },
    watchItem (componentItems) {
      this.componentItems = []
      this.componentItems = componentItems
    },
    getContainerClass () {
      let classResult = ''
      classResult += this.fullWidth ? 'mw-100 ' : ''
      classResult += this.noContainerPadding ? 'p-0 ' : ''
      return classResult
    },
    changeSelection (selected) {
      return new Promise(resolve => {
        return resolve(selected !== null ? !selected : false)
      })
    },
    checkSelected () {
      const stackedModeOn = this.stackedModeOn
      const checkedRows = stackedModeOn
        ? document.querySelectorAll('button[true-value="true"]')
        : document.querySelectorAll('div[true-value="true"]')
      const uncheckedRows = stackedModeOn
        ? document.querySelectorAll('button[true-value="false"]')
        : document.querySelectorAll('div[true-value="false"]')
      if (checkedRows && checkedRows.length !== 0) {
        checkedRows.forEach(checkbox => {
          if (checkbox.parentNode) {
            const firstParent = checkbox.parentNode
            if (firstParent.parentNode) {
              const secondParent = firstParent.parentNode
              if (secondParent.parentNode) {
                const rowIndex = checkbox.parentNode.parentNode.parentNode.getAttribute(
                  'aria-rowindex'
                )
                if (rowIndex) {
                  checkbox.parentNode.parentNode.parentNode.className = stackedModeOn
                    ? rowIndex % 2 === 0 ? '' : '' : ''
                } else {
                  checkbox.parentNode.parentNode.parentNode.className = stackedModeOn
                    ? '' : ''
                }
              }
            }
          }
        })
      }

      if (uncheckedRows && uncheckedRows.length !== 0) {
        uncheckedRows.forEach(checkbox => {
          if (checkbox.parentNode) {
            const firstParent = checkbox.parentNode
            if (firstParent.parentNode) {
              const secondParent = firstParent.parentNode
              if (secondParent.parentNode) {
                checkbox.parentNode.parentNode.parentNode.className = ''
              }
            }
          }
        })
      }
      this.checkTableRows()
    },
    checkTableRows () {
      const flexibleRow = document.querySelectorAll('td[data-label=""]')
      if (flexibleRow && flexibleRow.length !== 0) {
        flexibleRow.forEach(row => {
          row.className = this.stackedModeOn ? 'flexible-row' : ''
        })
      }
    },
    getFields (componentFields, customFields) {
      let editedFields = componentFields
      if (customFields && customFields.length !== 0) {
        customFields.forEach(field => {
          if (field.position) {
            const p1 = slice(editedFields, 0, field.position)
            const p2 = slice(
              editedFields,
              field.position,
              editedFields.length
            )
            p1.push(field)
            editedFields = concat(p1, p2)
          } else {
            editedFields.push(field)
          }
        })
      }

      return editedFields
    },
    excel (fileName, customFields) {
      return Vue.excel(
        customFields || this.fields,
        this.componentItems,
        fileName
      )
    },
    resetSearch () {
      this.filter = null
    },
    itemSelected (item, val) {
      item.selected = val
      this.$emit('rowSelected', item)
      this.allChecked = Vue.checkAllSelected(
        this.componentItems,
        this.perPage,
        this.currentPage
      )
      this.checkSelected()
    },
    getCustomField (field) {
      return `cell(${field.key})`
    },
    getTheadTRClass () {
      const fields = this.componentFields
      let cols = 0

      fields.forEach(field => {
        if (field.key === 'edit' || field.key === 'delete' || field.key === 'info' || field.key === 'download') cols++
      })

      if (cols === 1) return 'first-table-cols'
      return cols !== 0 ? `first-${cols + '-'}table-cols` : ''
    }
  }
}
</script>

<style>
  .tableContainerNotFixed {
    position: relative !important;
    overflow: auto !important;
  }

  .notFixedTableContainer {
    white-space: nowrap !important;
    max-width: 100% !important;
  }

  .notFixed {
    max-width: 60rem !important;
  }

  .search-icon {
    height: 100%;
    width: 100%;
    display: inline-table;
    align-items: center;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }

  .nw-clear-search {
    height: 100%;
    width: 100%;
    display: inline-table;
    align-items: center;
  }
</style>
